"use strict";
import { useId, useCallback } from "react";
import { isArrowUp, isArrowDown } from "../../util/key-codes.js";
import { shiftInRange } from "../../util/helpers.js";
function useFocusList() {
  const name = useId();
  const onKeyDown = useCallback(
    (event) => {
      if (!isArrowUp(event) && !isArrowDown(event)) {
        return;
      }
      event.preventDefault();
      const items = document.querySelectorAll(
        `[data-focus-list="${name}"]`
      );
      const currentEl = event.target;
      const currentIndex = Array.from(items).indexOf(currentEl);
      const offset = isArrowUp(event) ? -1 : 1;
      const newIndex = shiftInRange(currentIndex, offset, 0, items.length - 1);
      const newEl = items.item(newIndex);
      newEl.focus();
    },
    [name]
  );
  return { "data-focus-list": name, onKeyDown };
}
export {
  useFocusList
};
